import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatChipInputEvent, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { EMAIL_PATTERN } from '../util/constants';

@Component({
  selector: 'app-mail',
  templateUrl: './mail.component.html',
  styleUrls: ['./mail.component.scss']
})
export class MailComponent implements OnInit, OnDestroy {

  mailForm: any;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  mails = [];
  signers = [];

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<MailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.signers = data.signers.map(item => item.email_address);
  }

  ngOnInit() {
    this.mailForm = this.buildMailGroup();
    if (this.data.isCancelled) {
      this.mailForm.addControl('reason', new FormControl('', Validators.required));
    }
  }

  buildMailGroup(): FormGroup {
    return this.formBuilder.group({
      cc_email_addresses: [''],
      subject: ['', Validators.required],
      message: ['']
    });
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      this.mails.push(value.trim());
    }
    if (input) {
      input.value = '';
    }
  }

  remove(mail): void {
    const index = this.mails.indexOf(mail);
    if (index >= 0) {
      this.mails.splice(index, 1);
    }
  }

  sendMail(formValues) {
    const cc_mail = [];
    this.mails.forEach(mail => {
      const validMail = EMAIL_PATTERN.test(mail);
      if (validMail) {
        cc_mail.push(mail);
      }
    });
    formValues.cc_email_addresses = cc_mail;
    formValues.signers = this.data.signers;
    this.dialogRef.close(formValues);
  }

  closeMail() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.mailForm = null;
    this.selectable = null;
    this.removable = null;
    this.addOnBlur = null;
    this.mails = null;
    this.signers = null;
    this.formBuilder = null;
    this.dialogRef = null;
    this.data = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/mail/mail.component.ts